export default __webpack_public_path__ + "static/media/roi-total-cost.7b2fe824.svg";